// extracted by mini-css-extract-plugin
export var contentCard = "bL_f0";
export var gridBase = "bL_fX";
export var gridElement = "bL_f1";
export var gridTumbleIn = "bL_f2";
export var heightAuto = "bL_fZ";
export var heightFull = "bL_fY";